import {
  fetchLive,
  liveReminderSignUp,
  fetchUserLiveReminder,
  getScheduled,
  getLiveStatus
} from '@/api/live.api'

const state = {
  livesScheduled: [],
  live: {},
  hasLiveReminder: false
}

const mutations = {
  setLivesScheduled (state, lives) {
    state.livesScheduled = lives
  },
  setLive (state, live) {
    state.live = live
  },
  setHasLiveReminder (state, status) {
    state.hasLiveReminder = status
  }
}

const getters = {
  livesScheduled (state) {
    return state.livesScheduled
  },
  live (state) {
    return state.live
  },
  hasLiveReminder ({ hasLiveReminder }) {
    return hasLiveReminder
  }
}

const actions = {
  async updateLiveStatus ({ getters }) {
    const live = getters.live
    const status = await getLiveStatus(live.id)

    if (live.is_started != status.is_started) {
      live.is_started = status.is_started
    }

    return status
  },
  async getLivesScheduled ({ commit }) {
    const lives = await getScheduled()
    commit('setLivesScheduled', lives)
  },
  fetchLive ({ commit }, liveId) {
    return fetchLive(liveId)
      .then(live => commit('setLive', live))
  },
  async liveReminderSignUp ({ commit }, liveId) {
    commit('setHasLiveReminder', true)
    return liveReminderSignUp(liveId)
  },
  async fetchUserLiveReminder ({ commit }, liveId) {
    const reminder = await fetchUserLiveReminder('me', liveId)
    commit('setHasLiveReminder', !!reminder)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
